/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportData } from './reportData';


export interface MonitoringReportResponseDTO { 
    report_id?: string;
    serialnumber?: string;
    start?: string;
    stop?: string;
    status?: string;
    data?: ReportData;
    timezone?: string;
    manufacturer?: string;
    yearOfManufacture?: string;
    machineDisplayName?: string;
}

